import { defineMessage, useIntl } from 'react-intl';

const title = defineMessage({
  id: 'slot.joe.label',
  defaultMessage: 'Bonus Club',
});

// The visible label omits "jö", the accessible name carries the full program name
const ariaLabel = defineMessage({
  id: 'slot.joe.aria-label',
  defaultMessage: 'jö Bonus Club',
});

export const useJoeLink = () => {
  const { formatMessage } = useIntl();

  return {
    href: '/service-hilfe/joe-bonus-club',
    label: formatMessage(title),
    ariaLabel: formatMessage(ariaLabel),
  };
};
